import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAdyen } from '../../../../../../context/Adyen/context.js';
import '../../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { useValidateShippingData } from '../utility-hooks/use-validate-shipping-data.js';
import { useTransactionInfo } from './use-transaction-info.js';

var ref, ref1;
const getSharedConfig = ({ locale , cartPrices , currency , country , transactionInfo , onAuthorized  }, config, merchantId, gatewayMerchantId)=>{
    var ref5, ref2, ref3, ref4;
    return {
        buttonLocale: locale,
        buttonSizeMode: 'fill',
        allowedAuthMethods: config === null || config === void 0 ? void 0 : (ref5 = config.googlepay) === null || ref5 === void 0 ? void 0 : ref5.allowedAuthMethods,
        allowedCardNetworks: config === null || config === void 0 ? void 0 : (ref2 = config.googlepay) === null || ref2 === void 0 ? void 0 : ref2.allowedCardNetworks,
        amount: {
            value: (ref = cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice) !== null && ref !== void 0 ? ref : 0,
            currency
        },
        countryCode: country,
        transactionInfo,
        onAuthorized: (paymentData)=>{
            onAuthorized === null || onAuthorized === void 0 ? void 0 : onAuthorized(paymentData);
        },
        environment: (ref1 = config === null || config === void 0 ? void 0 : (ref3 = config.googlepay) === null || ref3 === void 0 ? void 0 : ref3.environment) !== null && ref1 !== void 0 ? ref1 : 'TEST',
        configuration: {
            gatewayMerchantId: gatewayMerchantId !== null && gatewayMerchantId !== void 0 ? gatewayMerchantId : '',
            merchantId,
            merchantName: config === null || config === void 0 ? void 0 : (ref4 = config.googlepay) === null || ref4 === void 0 ? void 0 : ref4.merchantName
        }
    };
};
const getRegularConfig = (configProps, config, merchantId, gatewayMerchantId)=>{
    const sharedConfig = getSharedConfig(configProps, config, merchantId, gatewayMerchantId);
    return swcHelpers.objectSpread({}, sharedConfig, {
        buttonType: 'pay',
        type: 'paywithgoogle'
    }, configProps.onClick ? {
        onClick: configProps.onClick
    } : {}, {
        isExpress: false
    });
};
const getExpressConfig = (configProps, config, merchantId, gatewayMerchantId)=>{
    const sharedConfig = getSharedConfig(configProps, config, merchantId, gatewayMerchantId);
    const expressConfigWithoutShippingAddress = swcHelpers.objectSpread({}, sharedConfig, {
        buttonType: 'checkout',
        type: 'googlepay',
        isExpress: false,
        emailRequired: true,
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        },
        shippingAddressParameters: {
            allowedCountryCodes: [
                configProps.country
            ],
            phoneNumberRequired: true
        },
        shippingOptionRequired: false
    });
    return configProps.shippingAddressRequired ? swcHelpers.objectSpread({}, expressConfigWithoutShippingAddress, {
        callbackIntents: [
            'SHIPPING_ADDRESS',
            'PAYMENT_AUTHORIZATION'
        ],
        shippingAddressRequired: true,
        paymentDataCallbacks: {
            onPaymentDataChanged (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { callbackTrigger , shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (callbackTrigger === 'SHIPPING_ADDRESS' && configProps.validateShippingData) {
                        const { isPaymentDataValid , error  } = configProps.validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                        }
                    }
                    resolve(paymentDataRequestUpdate);
                });
            },
            onPaymentAuthorized (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (configProps.validateShippingData) {
                        const { isPaymentDataValid , error  } = configProps.validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                            paymentDataRequestUpdate.transactionState = 'ERROR';
                        }
                    }
                    paymentDataRequestUpdate.transactionState = 'SUCCESS';
                    resolve(paymentDataRequestUpdate);
                });
            }
        }
    }) : expressConfigWithoutShippingAddress;
};
const useGooglePayConfig = (props)=>{
    const { config  } = useAdyen();
    const [mapTransactionInfo] = useTransactionInfo();
    const validateShippingData = useValidateShippingData();
    const propsRef = React.useRef(props);
    React.useEffect(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const regularGooglePayConfig = (merchantId, gatewayMerchantId)=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getRegularConfig(swcHelpers.objectSpread({}, propsRef.current, {
            transactionInfo
        }), config, merchantId, gatewayMerchantId);
    };
    const expressGooglePayConfig = (merchantId, gatewayMerchantId, shippingAddressRequired = false)=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getExpressConfig(swcHelpers.objectSpread({}, propsRef.current, {
            cartPrices: propsRef.current.cartPrices,
            transactionInfo,
            validateShippingData,
            shippingAddressRequired
        }), config, merchantId, gatewayMerchantId);
    };
    return {
        regularGooglePayConfig,
        expressGooglePayConfig
    };
};

export { useGooglePayConfig };
//# sourceMappingURL=use-google-pay-config.js.map
